import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import TargetForm from "./TargetForm/TargetForm";
import { dirname } from "../../../util/resourcePath";

import Loader from "../../general/Loader";
import EmptyPage from "../../general/EmptyPage";

const TargetInputs = (props) => {
	const [selectedSite, setSelectedSite] = useState(null);
	const [reload, setReload] = useState(true);

	const directory = dirname();

	useEffect(() => {
		if (
			(selectedSite == null && props.selectedSite != null) ||
			(props.selectedSite != null &&
				selectedSite != null &&
				props.selectedSite != null &&
				selectedSite.site_id != props.selectedSite.value.site_id)
		)
			setSelectedSite(props.selectedSite.value);
	}, [props.selectedSite]);

	useEffect(() => {
		if (selectedSite != null && !reload) setReload(true);
	}, [selectedSite]);

	return (
		<div className="perf-table panel panel-default">
			<div className="panel-heading ">
				<Row>
					<Col md="6">
						<h2 className="panel-title">
							<span
								className="glyphicon glyphicon-screenshot"
								aria-hidden="true"
							></span>{" "}
							Target Inputs -{" "}
							{selectedSite != null ? selectedSite.site_name : ""}
						</h2>
					</Col>
					<Col md="6">
						<img
							src={`${directory}/images/reload.png`}
							onClick={() => {
								setReload(true);
							}}
							style={{
								height: "35px",
								cursor: "pointer",
								float: "right",
							}}
							alt="logo"
						/>
					</Col>
				</Row>
			</div>
			{reload && selectedSite != null && (
				<Loader
					translucent={true}
					customStyle={{
						width: "150px",
						height: "150px",
						position: "fixed",
						left: "45%",
						top: "45%",
					}}
				/>
			)}
			{selectedSite != null ? (
				<TargetForm
					selectedSite={selectedSite}
					reload={reload}
					setReload={setReload}
				/>
			) : (
				<EmptyPage message={"No site selected"} />
			)}
		</div>
	);
};

export default TargetInputs;
